<template>
  <div class="cart-container lx-h100">
    <!-- 选择地址 -->
    <!-- <el-dialog :visible.sync="formData.maskShow" center :show-close="false"> -->
      <!-- <subAddress ref="subAddress" @onCancel="handleAddressCancel" @update:show="handleAddressCancel" @onChange="handleAddressChange" /> -->
    <!-- </el-dialog> -->
    <!-- 委托自动发货 -->
    <el-dialog :visible.sync="formData.showApply" center :show-close="false">
      <!-- <apply-goods
       :props="sub.showGoodsData"
       @confirm-delivery="getConfirmDeliveryHandle"
       @onCancel="cancleShowApplyHandle"
       @watch-auto-send-flag="watchAutoSendFlagHandle"
     /> -->
    </el-dialog>
    <full-con isHidden>
      <div slot="breadcrumb-right" class="cart-search-in-breadcrumb">
        <Search />
      </div>
      <div slot="full" class="lx-h100 lx-flex-column">
        <el-row class="lx-flex-shrink-0 top-info-row">
          <el-col :span="12" class="row-left">
            <el-row>
              <el-col :span="3" class="Accessories-title">{{ $t("createOrder.createOrder2") }}: </el-col>
              <el-col :span="21" class="Accessories">
                <el-row>
                  <el-col :span="4"> {{ $t("createOrder.createOrder3") }}： </el-col>
                  <el-col :span="2">
                    {{ userInfo.paperLabelCount }}
                  </el-col>
                  <el-col :span="4"> {{ $t("createOrder.createOrder4") }}： </el-col>
                  <el-col :span="2">
                    {{ userInfo.washingMark }}
                  </el-col>
                  <el-col :span="4"> {{ $t("createOrder.createOrder5") }}： </el-col>
                  <el-col :span="2">
                    {{ userInfo.signCount }}
                  </el-col>
                  <el-col :span="4"> {{ $t("createOrder.createOrder6") }}： </el-col>
                  <el-col :span="2">
                    {{ userInfo.accessoriesCount }}
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12" class="row-right">
            <div class="lx-flex-row-end">
              <!-- <el-button class="search-btn btn-blue" @click="messageAdd">{{
                $t("createOrder.createOrder101")
              }}</el-button> -->
              <span style="display: inline-block; padding-right: 20px; padding-top: 6px" class=""
                >{{ $t("createOrder.createOrder7") }}：{{ userInfo.balance | thousandSeparator }}元</span
              >
              <el-button class="form-btn btn-green" @click="toRecharge">{{ $t("createOrder.createOrder8") }}</el-button>

              <span>
                <el-button class="search-btn btn-blue download" @click="downloadTemplate">{{ $t("address.address42") }}</el-button>
                <div style="font-size: 12px; color: red">{{ $t("cart.downloadTemplateVersion") }}：2026/10/31</div>
              </span>

              <!-- 批量上传 -->
              <batch-upload @success="onBatchImport"></batch-upload>
            </div>
          </el-col>
        </el-row>
        <div style="display: flex; justify-content: space-between; align-items: center">
          <!--自动创建批次start-->
          <div v-if="this.bundle == '1'">
            <!-- <el-button class="search-btn btn-blue" style="margin-right: 10px" @click="handleOnChange(-1)">{{
              $t("cart.applyMessage22" || '一键选择收货地址')
            }}</el-button> -->
            <el-button class="search-btn btn-blue" style="margin-right: 10px" @click="handleTwoChange()">{{ $t("cart.applyMessage23" || '一键委托发货') }}</el-button>
            <el-button v-show="isAllSelectShow" class="search-btn btn-blue" @click="selectShipHandle()">{{ $t('cart.applyMessage31' || '批量选择进口商信息') }}</el-button>
          </div>
          <!-- 分页        :page-sizes="[5, 10, 15, 20]" @size-change="($event)=>tableCheck.page.pageSize = $event" -->
          <el-pagination
            :layout="tableCheck.page.layout"
            :total="tableCheck.page.total"
            :current-page.sync="tableCheck.page.pageNum"
            background
            :page-size.sync="tableCheck.page.pageSize"
            @current-change="tableCheck.page.pageChange"
            @prev-click="tableCheck.page.prevClick"
            @next-click="tableCheck.page.nextClick"
          />
        </div>
        <!-- 表格  height="auto" 随便给个字符串，固定表头会加入滚动条的宽度-->
        <div class="table-container lx-flex-grow-1 lx-hidden lx-pt10 lx-relative" style="display: flex; flex-direction: column">
          <el-table v-loading.body="isSpin" :data="tableCheck.tableData" border height="auto" row-key="id" stripe>
            <el-table-column type="select" width="40" align="center">
              <template #header>
                <div>{{ $t("createOrder.createOrder120") }}</div>
<!--                <div>{{ $t("createOrder.createOrder121") }}</div>-->
              </template>
              <template #default="{ row, $index }">
                <div style="align-items: center;">{{ tableCheck.page.updateIndex($index) }}</div>
                <el-checkbox :value="tableCheck.selectKeys.includes(row.id)" @change="tableCheck.onChange(row)"></el-checkbox>
              </template>
            </el-table-column>
            <!--<el-table-column width="50" align="center">-->
            <!--  <template #header> {{ $t("createOrder.createOrder120") }} </template>-->
            <!--  <template #default="{ row, $index }">-->
            <!--    {{ tableCheck.page.updateIndex($index) }}-->
            <!--  </template>-->
            <!--</el-table-column>-->
            <el-table-column :label="$t('createOrder.createOrder10')" width="auto" align="center">
              <template #default="{ row, $index }">
                <el-button class="list-btn btn-red" @click="doDelete(row, $index)">{{ $t("delete") }}</el-button>
                <el-button class="list-btn btn-green" @click="doCopy(row, $index)">{{ $t("laund.laund8") }}</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="taobaoUrl" :label="$t('createOrder.createOrder12')" min-width="120">
              <template #default="{ row, $index }">
                <el-form>
                  <el-form-item class="no-label">
                    <!-- {{ sumRulesForm('rulesTest', $index) }} -->
                    <el-input maxlength="1000"  v-model="row.taobaoUrl" size="small" @blur="blurTaobaoUrl(row, $index)" clearable></el-input>
                  </el-form-item>
                </el-form>
              </template>
            </el-table-column>
            <el-table-column :label="$t('createOrder.createOrder13')" min-width="400" align="center">
              <template #default="{ row, $index }">
                <el-form :model="row" label-width="auto" :ref="sumRulesForm('rulesGoods', $index)" :rules="initRules(row).goods">
                  <el-row>
                    <el-col :span="24">
                      <el-form-item prop="goodsName" :label="$t('createOrder.createOrder116')">
                        <el-input v-model="row.goodsName" size="small" clearable></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item prop="goodsCount" :label="$t('createOrder.createOrder15')">
                        <el-input
                          v-model="row.goodsCount"
                          size="small"
                          type="number"
                          @input="($event) => (row.goodsCount = format.Number($event, 0, 99999))"
                          @change="saveForm([row])"
                          @mousewheel.native.prevent
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item prop="price" :label="$t('createOrder.createOrder16')">
                        <el-input
                          v-model="row.price"
                          size="small"
                          type="number"
                          @input="($event) => (row.price = format.Number($event, 2, 99999999))"
                          @change="saveForm([row])"
                          @mousewheel.native.prevent
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item prop="colour" :label="$t('createOrder.createOrder17')">
                        <el-input v-model="row.colour" @blur="blurSpec(row)" size="small"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item prop="goodsSize" :label="$t('createOrder.createOrder18')">
                        <el-input v-model="row.goodsSize" @blur="blurSpec(row)" size="small"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item prop="goodsNumber" :label="$t('createOrder.createOrder122')">
                        <el-input v-model="row.goodsNumber" size="small"></el-input>
                      </el-form-item>
                      <span class="small-span">貴社商品の管理コード（ハウスコード）を入力してください</span>
                    </el-col>
                  </el-row>
                </el-form>
              </template>
            </el-table-column>
            <el-table-column :label="$t('createOrder.createOrder112')" width="150" align="center">
              <template #default="{ row, $index }">
                <!-- 国内运单号 -->
                <el-form
                  :model="row"
                  :ref="sumRulesForm('rulesFreight', $index)"
                  :rules="initRules(row).chineseFreight"
                  label-position="top"
                  label-width="100%"
                >
                  <el-form-item prop="trackingNumber" class="no-label line-height-30" :label="$t('orderList.orderList5')">
                    <el-input v-model="row.trackingNumber" maxlength="50" size="small" :disabled="!!Number(row.agentFlag)"></el-input>
                  </el-form-item>
                </el-form>
              </template>
            </el-table-column>
            <!-- 图片 -->
            <el-table-column prop="pictureUrl" :label="$t('feedback.feedback9')" width="auto" align="center">
              <template #default="{ row, $index }">
                <my-upload v-model="row.pictureUrl" size="mini" accept=".png,.jpeg,.jpg" :limit="1" />
              </template>
            </el-table-column>
            <!-- pdf -->
            <el-table-column class-name="pdfwj" prop="pdfName" :label="$t('createOrder.createOrder22')" width="200px" align="center">
              <template #default="{ row, $index }">
                <my-upload
                  v-model="row.pdfAttachment"
                  size="mini"
                  isJson
                  mode="array"
                  :keyObject="{ url: 'url', name: 'name' }"
                  :limit="5"
                  listType="text"
                >
                  <el-button class="list-btn btn-blue"> {{ $t("createOrder.createOrder20") }}</el-button>
                </my-upload>
              </template>
            </el-table-column>
            <el-table-column prop="agentFlag" :label="$t('createOrder.createOrder99')" width="110" align="center">
              <template #default="{ row, $index }">
                <!-- 代为购买 -->
                <el-form label-position="top" label-width="100%">
                  <el-form-item>
                    <label>{{ $t("createOrder.createOrder21") }}</label>
                    <el-select
                      :disabled="!Number(agentFlagUser)"
                      @change="agentFlagchange(row.agentFlag, $index, row)"
                      v-model="row.agentFlag"
                      :placeholder="$t('address.address38')"
                      size="small"
                    >
                      <el-option v-for="item in agentFlagOption" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
              </template>
            </el-table-column>
            <el-table-column prop="fnsku" :label="$t('createOrder.createOrder23')" min-width="220" align="center">
              <template #default="{ row, $index }">
                <!-- FBA/YFF/ZOZO/RSL/STOCKCREW -->
                <el-form :model="row" class="aabbcc" :show-message="false" :ref="sumRulesForm('rulesFBA', $index)" :rules="initRules(row).FBA" label-width="107px">
                  <el-row>
                    <el-col :span="24">
                      <el-form-item prop="orderType">
                        <el-select
                          v-model="row.orderType"
                          :placeholder="$t('address.address38')"
                          size="small"
                          @change="orderTypeChange(row.orderType, $index, row)"
                        >
                          <el-option v-for="item in fbaOption" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item
                        :class="['2','3','5'].includes(row.orderType) ? 'foldLabel' : ''"
                        prop="fnsku"
                        :label="row.orderType !== '1' ? row.skuLabel : 'バーコード'"
                      >
                        <el-input v-model="row.fnsku" size="small" clearable :disabled="!row.fnskuEnabled"></el-input>
                      </el-form-item>
                      <span class="small-span" v-if="['1'].includes(row.orderType)"
                        >商品に記載されている（または貼付されている）バーコードの情報を入力してください</span
                      >
                      <div style="text-align: left">
                        <span class="small-span" v-if="['0'].includes(row.orderType)">Amazonに生成したバーコードを入力してください</span>
                      </div>
                      <span class="small-span" v-if="['2', '3', '4', '5'].includes(row.orderType)"
                        >商品に記載されている（または貼付されている）バーコードの情報を入力してください</span
                      >
                    </el-col>
                    <el-col :span="24">
                      <el-form-item prop="goodsNameCus" :label="$t('createOrder.createOrder113')">
                        <el-input
                          maxlength="200"
                          v-model="row.goodsNameCus"
                          size="small"
                          clearable
                          :placeholder="'店舗商品表示名を入力してください'"
                          :disabled="!row.fnskuEnabled"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="['0'].includes(row.orderType)">
                      <el-form-item prop="asin" label="ASIN">
                        <el-input v-model="row.asin" size="small" clearable :disabled="!row.fnskuEnabled"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </template>
            </el-table-column>
            <!-- 检品选项 -->
            <el-table-column
              prop="checkProjectArray"
              :label="$t('createOrder.createOrder25') + '&' + $t('createOrder.createOrder95')"
              align="center"
              min-width="250"
            >
              <template #default="{ row, $index }">
                <el-form label-width="auto">
                  <el-form-item class="no-label" clearable>
                    <el-select
                      multiple
                      v-model="row.checkProjectArray"
                      :placeholder="$t('address.address38')"
                      size="small"
                      @change="configCheckChanged(row, $index)"
                      class="height-limited-select"
                    >
                      <el-option v-for="(item, index) in inspectionOption" :key="index" :label="item.name" :value="item.nameCd"> </el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
                <my-upload
                  v-model="row.inspectionFileUrl"
                  size="mini"
                  :fileName.sync="row.inspectionFileName"
                  :limit="1"
                  accept=".doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf,.txt,.jpg,.jpeg,.png,.mp4,.xlsm"
                  listType="text"
                >
                  <el-button class="list-btn btn-blue"> {{ $t("createOrder.createOrder20") }}</el-button>
                </my-upload>
              </template>
            </el-table-column>
            <!-- <el-table-column class-name="jpwj" prop="inspectionFileName" :label="$t('createOrder.createOrder95')" width="360px" align="center">
              <template #default="{ row, $index }">
                <my-upload v-model="row.inspectionFileUrl" size="mini" :fileName.sync="row.inspectionFileName" :limit="1"
                  accept=".doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf,.txt,.jpg,.jpeg,.png,.mp4" listType="text">
                  <el-button class="list-btn btn-blue">
                    {{ $t("createOrder.createOrder20") }}</el-button>
                </my-upload>
              </template>
            </el-table-column> -->
            <el-table-column prop="laundryLabelId" :label="$t('createOrder.createOrder26')" width="120" align="center">
              <template #default="{ row, $index }">
                <el-form :model="row" :ref="sumRulesForm('rulesLabel', $index)" :rules="initRules(row).label" label-width="auto">
                  <el-form-item prop="laundryLabelId" class="mini-label">
                    <el-select
                      v-model="row.laundryLabelId"
                      :placeholder="$t('address.address38')"
                      size="small"
                      clearable
                      :disabled="!row.isTempEnabled"
                    >
                      <el-option v-for="item in laundryLabelOption" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="customerRemark" :label="$t('createOrder.createOrder111')" width="250">
              <template #default="{ row, $index }">
                <el-form label-width="auto">
                  <el-form-item class="no-label">
                    <div class="">
                      <el-input v-model="row.customerRemark" size="small" type="textarea" :rows="5"></el-input>
                    </div>
                  </el-form-item>
                </el-form>
              </template>
            </el-table-column>
            <!--自动创建批次start-->
            <el-table-column v-if="this.bundle == '1'" :label="$t('cart.applyMessage24')" prop="weituo" width="250" align="center">
              <template #default="{ row }">
                <!-- 收货信息 -->
                <div style="margin-top: 5px; padding: 5px; box-sizing: border-box">
                  <!-- <div>
                    <div style="display: flex; margin-top: 8px">
                      <el-input v-model="row.receiver" :placeholder="$t('cart.applyMessage26')" :readonly="true"> </el-input>
                      <el-button type="primary" @click="handleOnChange($index)">{{ $t("cart.applyMessage25" || '选择') }}</el-button>
                    </div>
                  </div> -->
                  <div class="auto-ship-switch">
                    <div style="margin: 5px 0">
                      <el-switch inactive-value="0" active-value="1" v-model="row.autoSendFlag" style="--el-switch-on-color: #00d92f" />
                      <span style="margin-left: 10px" :style="{ color: row.autoSendFlag == '1' ? '#43261a' : '#808080' }">{{
                          $t("cart.applyMessage27" || '委托自动发货')
                        }}</span>
                    </div>
                    <el-button type="primary" v-show="row.autoSendFlag == '1'" @click="selectShipHandle(row)">{{
                        row?.clearanceId ? $t("cart.applyMessage28" || '修改发货信息') : $t("cart.applyMessage29" || '选择进口商信息')
                      }}</el-button>
                  </div>
                </div>
              </template>
            </el-table-column>
            <!--自动创建批次end-->
            <!-- <el-table-column width="20"></el-table-column> -->
          </el-table>
          <div class="addOrder-btn-container lx-flex-row-between">
            <div class="lx-flex-shrink-0 lx-flex-row">
              <el-checkbox
                style="margin: 0 20px"
                :value="tableCheck.checkValue()"
                :indeterminate="tableCheck.checkIndeterminate()"
                @change="tableCheck.onCheckAll(tableCheck.dataSource)"
                >{{ $t("cart.cart7") }}</el-checkbox
              >
              <el-button @click="deleteRow()" icon="el-icon-minus" class="form-btn btn-red"
                >{{ $t("createOrder.batchDelete") }}({{ tableCheck.selectKeys.length }})</el-button
              >

              <el-button @click="addRow()" icon="el-icon-plus" class="form-btn btn-green">{{
                $t("createOrder.createOrder36" || "新增一行")
              }}</el-button>
            </div>
            <div class="lx-flex-grow-1 lx-flex-row lx-ml16 lx-mr16">
              <span class="lx-flex-1">{{ $t("cart.cart1") }}：{{ tableCheck.page.total }}</span>
              <span class="lx-flex-1">{{ $t("cart.cart2") }}：{{ sumCartPrice() }}{{ $t("orderList.orderList121") }}</span>
              <span class="lx-flex-1">{{ $t("cart.cart3") }}：{{ sumCartPrice(tableCheck.selectObjs) }}{{ $t("orderList.orderList121") }}</span>
              <span class="lx-flex-1">{{ $t("cart.cart5") }}：{{ oldSaveTime | dateFormatToSecond | empty }}</span>
            </div>
            <div class="lx-flex-shrink-0 lx-flex-row">
              <el-button class="lx-flex-shrink-0" @click="submitOrder" type="primary" style="width: 130px"
                >{{ $t("submitOrder") }}{{ `(${tableCheck.selectObjs.length})` }}</el-button
              >
              <el-button class="lx-flex-shrink-0" @click="saveForm()" type="warning" style="width: 130px">{{ $t("baoc") }}</el-button>
            </div>
          </div>
        </div>
      </div>
    </full-con>

    <!-- 联系我们 -->
    <!-- <MessageTip :visiable.sync="isVisiable" :title="$t('createOrder.createOrder101')" :userName="userInfo.userName"
      :messageType="$t('mess.mess56')" httpUrl="cmUser/message/sendMessage" @confirm="isVisiable = false">
    </MessageTip> -->

    <!--商品详情 -->
    <el-dialog :title="goodsDialogTitle" :visible.sync="goodsDialogVisible" width="80%" top="8vh" custom-class="goods-detail-dialog" @close="goodsDialog">
      <template #title>
        <div class="goods-dialog-heading">
          <strong class="goods-dialog-title">{{ goodsDialogTitle }}</strong>
          <span class="goods-dialog-description">{{ goodsDialogDescription }}</span>
        </div>
      </template>
      <cartDetails :subProps.sync="subProps" :is-add-mode="!hasGoodsInfo" :visible.sync="goodsDialogVisible" @onChange="detailsChange" @addNewRow="addNewRow" />
    </el-dialog>
  </div>
</template>

<script>
import cartDetails from "./cartDetails.vue";
import Search from "./search.vue";
import MessageTip from "./cmp/MessageTip";
import BatchUpload from "./cmp/BatchUpload";
import Oss from "@/assets/js/oss.js";
import { onBeforeunload, closeBeforeunload, throttle } from "@/assets/js/utils";
import { PageList, FormVerify, Format } from "@/class";
const defaultCheck = ["baseCheck"]; // 默认检品选项
const formData = {
  id: null,
  trackingNumber: "", // 国内运单号
  taobaoUrl: "", // 商品链接
  goodsName: "", // 名称
  goodsCount: "", // 数量
  price: "", // 单价
  colour: "", // 颜色
  goodsSize: "", // 尺寸
  goodsNumber: "", // sku
  pictureUrl: "", // 图片
  pictureName: "",
  pdfName: "", // 文件
  pdfUrl: "",
  agentFlag: "0", // 是否代购
  // putIntent: '', // 包装意向
  orderType: "1", // FBA/YFF/ZOZO/RSL/STOCKCREW
  fnskuEnabled: false, // FBA/YFF/ZOZO/RSL/STOCKCREW 是否可选
  asinRequired: false, //asin必填
  skuLabel: "", // fnsku的label名称
  fnsku: "", // fnsku
  goodsNameCus: "", // 品名
  asin: "", // asin
  checkProjectArray: defaultCheck, // 检品选项
  inspectionFileName: "", // 检品文件
  inspectionFileUrl: "",
  laundryLabelId: "", // 水洗标模板
  isTempEnabled: false, // 水洗标模板是否可选
  customerRemark: "", // 备注
  isChecked: false,
  autoSendFlag: '0', // 自动发货标识
  maskShow: false, // 地址选择
  addressIndex: -1, // 地址选择
  showApply: false, // 委托自动发货
};
export default {
  name: "Cart",
  components: {
    MessageTip,
    BatchUpload,
    cartDetails,
    Search,
  },
  data() {
    let tableCheck = new PageList();
    return {
      format: Format, //格式化
      tableCheck: tableCheck,
      subProps: undefined, //
      serviceRate: 0, //客户服务费率
      createTime: 0, //创建时间
      endTime: 0, //结束时间
      isSpin: true,
      userInfo: {},
      isVisiable: false,
      formData: this._.cloneDeep(formData),
      metaTableList: [], // 所有的\源数组
      agentFlagOption: [], // 是否代购
      laundryLabelOption: [], // 水洗标模板
      fbaOption: [], // FBA/YFF/ZOZO/RSL/STOCKCREW
      inspectionOption: [], // 检品选项
      //订单同捆 0关闭 1开启
      bundle: '0',
      flag: false,
      goodsDialogVisible: false, //商品dialog

      type: 0,
      item: "",
      listObj: [],
      fileListObj: {},
      pdfListObj: {},
      curRow: 0,
      curRowPDF: 0,
      curRowImg: 0,
      curRowFile: 0,
      imgDataObj: {
        policy: "",
        signature: "",
        key: "",
        ossaccessKeyId: "",
        dir: "",
        host: "",
        timeStamp: "",
      },
      pdfFileList: [],
      pdfDataObj: {
        policy: "",
        signature: "",
        key: "",
        ossaccessKeyId: "",
        dir: "",
        host: "",
        timeStamp: "",
      },
      fileDataObj: {
        policy: "",
        signature: "",
        key: "",
        ossaccessKeyId: "",
        dir: "",
        host: "",
        timeStamp: "",
      },
      oldSaveTime: "", // 上次保存时间
      isSubmit: false,
      scrollDom: null,
    };
  },
  watch: {
    "tableCheck.loading": {
      handler(val, old) {
        console.log("tableCheck,loading.val,", val);
        this.isSpin = val;
      },
    },
  },
  computed: {
    hasGoodsInfo() {
      const row = this.subProps && this.subProps.row;
      const goodsFields = ["goodsName", "colour", "goodsCount", "price", "goodsSize", "pictureUrl"];
      return !!row && goodsFields.some((field) => {
        const value = row[field];
        if (field === "goodsCount") return Number(value) > 0;
        return value !== null && value !== undefined && String(value).trim() !== "";
      });
    },
    goodsDialogTitle() {
      return this.$t(this.hasGoodsInfo ? "cart.editProductInfo" : "cart.addProduct");
    },
    goodsDialogDescription() {
      return this.$t(this.hasGoodsInfo ? "cart.editProductInfoHint" : "cart.addProductHint");
    },
    // 是否开启代为购买权限  0关闭 1开启
    agentFlagUser() {
      return this.userInfo.hotboomFlag === "1" ? "1" : "0";
    },
    // 检查是否有商品包含完整的收货信息
    showADFHAll() {
      return this.tableCheck.dataSource.some((item) => {
        return item.receiver;
      });
    },
    isAllSelectShow() {
      return this.tableCheck.dataSource.some((item) => {
        return item.autoSendFlag == '1';
      });
    },
  },
  created() {
    this.getUserInfo();
    setTimeout(() => {
      this.initData();
      this.getOldSaveTime();
    },1000)
  },
  mounted() {
    onBeforeunload();
  },
  filters: {
    thousandSeparator(num) {
      if (num === null || num === undefined) return '0'

      const numStr = String(num)
      const [integer, decimal] = numStr.split('.')
      const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

      return decimal ? `${formattedInteger}.${decimal}` : formattedInteger
    }
  },
  beforeRouteLeave(to, form, next) {
    if (form.name === "Cart" && !this.isSubmit) {
      this.isSubmit = false;
      next();
      closeBeforeunload();
      this.saveForm();
      // this.$confirm(this.$t("cart.cart4"), {
      //   confirmButtonText: this.$t("cart.cart10"),
      //   confirmButtonClass: "form-btn btn-blue",
      //   cancelButtonText: this.$t("cart.cart11"),
      //   cancelButtonClass: "form-btn btn-gray",
      //   showClose: false,
      //   showCancelButton: true,
      //   closeOnClickModal: false,
      //   closeOnPressEscape: false,
      // })
      //   .then(() => {
      //     this.isSubmit = false;
      //     next();
      //     closeBeforeunload();
      //     this.saveForm();
      //   })
      //   .catch(() => {
      //     this.isSubmit = false;
      //     next();
      //     closeBeforeunload();
      //   });
    } else {
      next();
    }
  },
  methods: {
    // 批量选择清关人信息
    selectHandle(){
      // 检查是否有选中的商品
      if (!this.tableCheck.selectKeys || this.tableCheck.selectKeys.length === 0) {
        this.$message({
          message: this.$t("cart.applyMessage30"),
          type: "warning",
        });
        return;
      }
      this.$modalDialog(() => import('./cmp/apply-goods.vue')).then(
          (data) => {
            this.tableCheck.tableData.forEach((row) => {
              // 只更新选中的商品行
              if (this.tableCheck.selectKeys.includes(row.id)) {
                this.$set(row, "logisticsCompanyId", data.logisticsCompanyId);
                this.$set(row, "route", data.route);
                this.$set(row, "senderConfigAddressInfoId", data.senderConfigAddressInfoId);
                this.$set(row, "attachment", data.attachment);
                this.$set(row, "receiverConfigAddressInfoId", data.receiverConfigAddressInfoId);
              }
            });
          },
          () => {}
      )
    },
    // 校验选中的商品的autoSendFlag是否为1  方法暂未使用
    checkAutoSendFlag() {
      const selectedRows = this.tableCheck.tableData.filter(row =>
        this.tableCheck.selectKeys.includes(row.id)
      );
      const invalidRows = selectedRows.filter(row => row.autoSendFlag !== '1');

      if (invalidRows.length > 0) {
        // 构建详细的错误信息，显示具体的商品位置
        const invalidRowsInfo = invalidRows.map((row, index) => {
          const tableIndex = this.tableCheck.tableData.findIndex(item => item.id === row.id);
          const pageNum = this.tableCheck.page.pageNum;
          const pageSize = this.tableCheck.page.pageSize;
          const rowInPage = (tableIndex % pageSize) + 1;
          return `第${pageNum}页第${rowInPage}行`;
        }).join('\n');

        this.$message({
          message: `以下商品未开启委托自动发货功能，请先开启：\n${invalidRowsInfo}`,
          type: "warning",
          duration: 8000,
          dangerouslyUseHTMLString: false
        });
        return false;
      }
      return true;
    },
    // 选择清关人信息
    selectShipHandle(row) {
      if (row) {
        console.log(row);
        this.$modalDialog(() => import('./cmp/apply-goods.vue'), {row}).then(
            (data) => {
              this.$set(row, "logisticsCompanyId", data.logisticsCompanyId);
              this.$set(row, "route", data.route);
              this.$set(row, "senderConfigAddressInfoId", data.senderConfigAddressInfoId);
              this.$set(row, "attachment", data.attachment);
              this.$set(row, "receiverConfigAddressInfoId", data.receiverConfigAddressInfoId);
              this.$set(row, "senderConfigAddressInfoName", data.senderConfigAddressInfoName);
              this.$set(row, "logisticeCompany", data.logisticeCompany);
              this.$set(row, "receiver", data.receiver);
            },
            () => {}
        )
      } else {
        // 批量操作：检查是否有选中的商品
        if (!this.tableCheck.selectKeys || this.tableCheck.selectKeys.length === 0) {
          this.$message({
            message: this.$t("cart.applyMessage30"),
            type: "warning",
          });
          return;
        }

        // 批量操作
        this.$modalDialog(() => import('./cmp/apply-goods.vue')).then(
            (data) => {
              // 批量更新选中的商品
              this.tableCheck.selectObjs.forEach((row) => {
                // 只更新选中的商品行
                if (this.tableCheck.selectKeys.includes(row.id) && row.autoSendFlag === '1') {
                  this.$set(row, "logisticsCompanyId", data.logisticsCompanyId);
                  this.$set(row, "route", data.route);
                  this.$set(row, "senderConfigAddressInfoId", data.senderConfigAddressInfoId);
                  this.$set(row, "attachment", data.attachment);
                  this.$set(row, "receiverConfigAddressInfoId", data.receiverConfigAddressInfoId);
                  this.$set(row, "senderConfigAddressInfoName", data.senderConfigAddressInfoName);
                  this.$set(row, "logisticeCompany", data.logisticeCompany);
                  this.$set(row, "receiver", data.receiver);
                }
              });
              console.log("已批量更新选中商品的进口商信息");
            },
            () => {}
        )
      }
    },
    // 一键委托发货
    handleTwoChange() {
      // 检查是否有选中的商品
      if (!this.tableCheck.selectKeys || this.tableCheck.selectKeys.length === 0) {
        this.$message({
          message: this.$t("cart.applyMessage30"),
          type: "warning",
        });
        return;
      }

      // 将选中商品的 autoSendFlag 改为 1
      this.tableCheck.selectObjs.forEach((row) => {
        if (this.tableCheck.selectKeys.includes(row.id)) {
          this.$set(row, "autoSendFlag", '1');
        }
      });

      console.log("已更新选中商品的 autoSendFlag 为 1");
    },
    handleOnChange(index) {
      // 如果是一键收货地址操作（index为-1），需要检查是否有选中的商品
      if (index === -1) {
        if (!this.tableCheck.selectKeys || this.tableCheck.selectKeys.length === 0) {
          this.$message({
            message: this.$t("cart.applyMessage30"),
            type: "warning",
          });
          return;
        }
      }

      this.formData.maskShow = true;
      this.formData.addressIndex = index;
    },
    handleAddressCancel() {
      this.formData.maskShow = false;
    },
    // 新增：处理地址选择变更
    handleAddressChange(addressData) {
      console.log("选中的地址数据:", addressData);

      // 获取当前选中的行索引
      const index = this.formData.addressIndex;

      if (index >= 0 && index < this.tableCheck.tableData.length) {
        // 更新指定行的收货人信息
        const row = this.tableCheck.tableData[index];

        // 组装收货人信息字符串
        const receiverInfo = `${addressData.receiverName || ""}`;

        // 更新 row.receiver 字段
        this.$set(row, "receiver", receiverInfo.trim());

        this.$set(row, "receiverConfigAddressInfoId", addressData.id);

        console.log("已更新行数据:", row);
      } else if (index === -1) {
        // 一键设置收货地址 - 只更新选中的商品
        this.tableCheck.tableData.forEach((row) => {
          // 只更新选中的商品行
          if (this.tableCheck.selectKeys.includes(row.id)) {
            const receiverInfo = `${addressData.receiverName || ""}`;
            this.$set(row, "receiver", receiverInfo.trim());
            this.$set(row, "receiverConfigAddressInfoId", addressData.id);
          }
        });

        console.log("已批量更新选中商品的地址信息");
      }

      // 关闭地址选择对话框
      this.formData.maskShow = false;
    },
    messageAdd() {
      const { MessageSend } = this;
      const list = [
        {
          key: "orderName",
          type: "elInput", //view
          label: this.$t("recharge.yhName"),
          vModel: this.userInfo.userName,
          vBind: { disabled: true },
        },
      ];
      // MessageSend.httpUrl = "cmUser/message/sendMessage";
      MessageSend.message.onAdd(this.$t("createOrder.createOrder101"), list[0]);
    },
    onBlur() {
      console.log(" this.tableData", this.tableCheck.tableData);
      console.log("this-table-chedk", this.tableCheck.dataSource);
    },
    detailsChange(id, data) {
      if (!this.tableCheck.selectKeys.includes(data.id)) {
        this.tableCheck.onChange(data);
      }
      const index = this.tableCheck.tableData.findIndex((row) => row.id === id);
      if (index < 0) {
        return;
      }
      this.tableCheck.tableData[index].pictureUrl = undefined;
      setTimeout(() => {
        this.tableCheck.setDataList(index, data);
        this.$set(this.tableCheck.tableData, index, data);
      }, 50);
    },
    // 初始化数据（默认数据放这里初始化）
    initData() {
      const fbaOption = [
        {
          label: this.$t("running.suspended0"),
          value: "1",
        },
        {
          label: "FBA",
          value: "0",
        },
        {
          label: "YFF",
          value: "2",
        },
        {
          label: "ZOZO",
          value: "3",
        },
        {
          label: "RSL",
          value: "4",
        },
        {
          label: "ストッククルー",
          value: "5",
        },
      ];
      const agentFlagOption = [
        {
          label: this.$t("running.suspended1"),
          value: "1",
        },
        {
          label: this.$t("running.suspended0"),
          value: "0",
        },
      ];
      this.fbaOption = fbaOption;
      this.agentFlagOption = agentFlagOption;
      Promise.all([this.getInspectionOption(), this.getCartList(), this.getLaundryLabelOption()]).then((data) => {
        this.inspectionOption = data[0]; //检品

        //如果客户拥有特殊检品选项，则查询合并
        if (this.userInfo.inspectOption != null && this.userInfo.inspectOption != "") {
          this.$http
            .get("/order/getNameList", {
              params: {
                inspectOption: this.userInfo.inspectOption,
                isPrivate: "1",
              },
            })
            .then((res) => {
              if (res.data.data != null && res.data.data.length > 0) {
                this.inspectionOption = this.inspectionOption.concat(res.data.data);
              }
            });
        }
        //购物车列表 data[1]
        this.laundryLabelOption = data[2]; //水洗模板
        console.log("水洗模板", this.laundryLabelOption);
        this.renderItemInfo();
      });
    },
    blurSpec(row){
      this.$set(row, "offerId", '');
      this.$set(row, "specId", '');
      this.$set(row, "sellerOpenId", '');
    },
    // 新增/批量导入时数据初始化
    renderItemInfo() {
      this.metaTableList.forEach((row, index) => {
        // 初始化 autoSendFlag 字段 测试补数据
        if (row.autoSendFlag === undefined || row.autoSendFlag === null) {
          row.autoSendFlag = '0';
        }
        // 代购权限 1代购，0非代购
        if (this.agentFlagUser === "1") {
        } else {
          row.agentFlag = "0";
          row.trackingNumber = "";
        }
        // 类型FBA/YFF/ZOZO/RSL/STOCKCREW
        if (["1", null, undefined].includes(row.orderType)) {
          row.fnsku = "";
          row.goodsNameCus = "";
          row.asin = "";
          row.fnskuEnabled = false;
        } else {
          row.skuLabel = this.setSku(row).skuLabel;
          row.skuPlaceolder = this.setSku(row).skuPlaceolder;
          row.fnskuEnabled = true;
        }

        if (row.orderType == "0") {
          row.asinRequired = true;
        } else {
          row.asinRequired = false;
        }

        if (row.checkProjectArray && row.checkProjectArray.length > 0) {
          row.checkProjectArray.forEach((item) => {
            if (item === "laundryLabel") {
              row.isTempEnabled = true;
            }
          });
        } else {
          row.checkProjectArray = [...defaultCheck];
        }
        this.tableCheck.dataSource.push({ ...row });
      });
      const { dataSource = [], page } = this.tableCheck;
      page.update();
      this.tableCheck.selectUpdate(dataSource);
    },

    // 初始化校验规则
    initRules(row) {
      let rules = {
        //商品较验
        goods: {
          goodsCount: [
            {
              required: true,
              // message: this.$t("createOrder.createOrder47"),
              message: this.$t("createOrder.createOrder84"),
              trigger: "blur",
            },
            {
              pattern: /^[1-9]\d*$/,
              // message: this.$t("createOrder.createOrder48"),
              message: this.$t("createOrder.createOrder84"),
              trigger: "blur",
            },
          ],
          price: [
            {
              required: true,
              // message: this.$t("createOrder.createOrder82"),
              message: this.$t("createOrder.createOrder84"),
              trigger: "blur",
            },
            {
              pattern: /(^(([1-9]([0-9]+)?)|(0{1}))(\.[0-9]{1,2})?$)/,
              // message: this.$t("createOrder.createOrder49"),
              message: this.$t("createOrder.createOrder84"),
              trigger: "blur",
            },
          ],
          colour: [
            {
              required: true,
              // message: this.$t("createOrder.createOrder81"),
              message: this.$t("createOrder.createOrder84"),
              trigger: "blur",
            },
          ],
        },
        //国内运单号
        chineseFreight: {
          trackingNumber: Number(row.agentFlag)
            ? []
            : [
                {
                  required: true,
                  message: this.$t("createOrder.createOrder62"),
                  trigger: "blur",
                },
                {
                  pattern: /^[a-zA-Z0-9]+$/,
                  message: this.$t("createOrder.createOrder63"),
                  trigger: "blur",
                },
              ],
        },
        //FBA品名
        FBA: {
          goodsNameCus: row.fnskuEnabled
            ? [
                {
                  required: true,
                  message: this.$t("createOrder.createOrder123"),
                  trigger: "blur",
                },
              ]
            : [],
          fnsku: row.fnskuEnabled
            ? [
                {
                  required: true,
                  message: this.$t("createOrder.createOrder123"),
                  trigger: "blur",
                },
                {
                  pattern: /^[a-zA-Z0-9_-]+$/,
                  message: this.$t("createOrder.createOrder123"),
                  trigger: "blur",
                },
              ]
            : [],
          asin:
            row.fnskuEnabled && row.asinRequired
              ? [
                  {
                    required: true,
                    message: this.$t("createOrder.createOrder123"),
                    trigger: "blur",
                  },
                ]
              : [],
        },
        //标签
        label: {
          //水洗标签
          laundryLabelId: row.isTempEnabled
            ? [
                {
                  required: true,
                  message: this.$t("createOrder.createOrder87"),
                  trigger: "blur",
                },
              ]
            : [],
        },
      };

      return rules;
    },
    setSku(row) {
      let skuLabel = "";
      let skuPlaceolder = "";
      if (row.orderType === "0") {
        skuLabel = "FNSKU";
        skuPlaceolder = "X00000001";
      }
      if (row.orderType === "2") {
        skuLabel = "検品コード※商品バーコード";
        skuPlaceolder = "hello-red";
      }
      if (row.orderType === "5") {
        skuLabel = "検品コード※商品バーコード";
        skuPlaceolder = "hello-red";
      }
      if (row.orderType === "3") {
        skuLabel = "ZOZOバーコード";
        skuPlaceolder = "ICH123456789";
      }
      if (row.orderType === "4") {
        skuLabel = `RSLバーコード`;
        skuPlaceolder = "123456789";
      }
      return {
        skuLabel: skuLabel,
        skuPlaceolder: skuPlaceolder,
      };
    },
    //获取服务费率-获取用户信息
    async getUserInfo() {
      const { data: res } = await this.$http.get("customer/getCustomerInfo");
      this.userInfo = res.data;
      this.serviceRate = res.data.serviceRate;
      this.bundle = res.data.bundle;
    },
    // 充值
    toRecharge() {
      this.$router.push({ name: "recharge" });
    },
    // 批量导入
    onBatchImport() {
      closeBeforeunload();
      this.isSpin = true;
      // this.tableData = this.tableData.concat(list) // 一次性导入渲染变慢
      // this.getCartList().then(() => {
      //     this.initRender()
      // })
      this.$router.go(0);
    },
    // 删除订单
    doDelete(row, index) {
      const url = `shopping/vehicle/delete/${row.id}`;
      this.$http.post(url).then(() => {
        this.$message.success(this.$t("success"));
        //删除虚拟数据
        this.tableCheck.delDataList(row.id, index);
        this.tableCheck.page.update();
      });
    },
    // 复制
    doCopy(row, index) {
      const url = `shopping/vehicle/copy/${row.id}`;
      this.$http.post(url).then((res) => {
        const { data } = res.data;
        let newRow = { ...row, id: data.id, trackingNumber: "" };
        //在前插入一行
        this.tableCheck.shiftRow(newRow);
      });
    },
    //输出一个动态form-rules
    sumRulesForm(refString, index) {
      const { page } = this.tableCheck;
      const idx = page.updateIndex(index - 1);
      let a = `${refString}${idx}`;
      return a;
    },
    //购物车价格计算 预计金额统计公式: 商品费+代购手续费+中国运费+检品费+标签费
    sumCartPrice(list = this.tableCheck.dataSource) {
      let goodsPrice = 0; //商品价格：
      let agentServiceFee = 0; //代购手续费
      let chineseFreightFee = 0; //中国运费
      let inspectionPrice = 0; //检品费
      let labelFee = 0; //标签费
      list.forEach((item) => {
        const { price = 0, goodsCount = 0 } = item;
        goodsPrice += Number(price) * Number(goodsCount);
        chineseFreightFee += Number(item.chineseFreightFee || 0);
        item.checkProjectArray.forEach((subItem) => {
          inspectionPrice += Number(this.inspectionOption.find((val) => subItem === val.nameCd)?.data);
        });
        agentServiceFee += Math.ceil(Number(item.chineseFreightFee || 0) * (this.serviceRate / 100), 2);
      });
      let a = goodsPrice + agentServiceFee + chineseFreightFee + inspectionPrice;
      return a.toFixed(2);
    },
    //文件列表回显
    sumFileList(row) {
      if (row.pdfAttachment) {
        let pdfAttachment = JSON.parse(row.pdfAttachment);
        return pdfAttachment || [];
      } else {
        return [];
      }
    },
    // 商品链接
    blurTaobaoUrl(row, index) {
      if (row.taobaoUrl) {
        this.subProps = {
          row: row,
          url: row.taobaoUrl,
          index: index,
          indexSource: this.tableCheck.page.updateIndex(index),
        };
        this.goodsDialogVisible = true;
      }
    },
    // 拉取得商品详情关闭弹框回调
    goodsDialog() {
      this.goodsDialogVisible = false;
    },
    // 模板下载
    downloadTemplate() {
      window.open("https://oytqc-oss.oss-cn-qingdao.aliyuncs.com/oytqc/ref/template.xlsm", "_blank");
    },
    //上传图片
    uploadImg(file) {
      const isJPG = file.file.type === "image/jpeg" || "image/jpg" || "image/png";
      if (!isJPG) {
        this.$message.error(this.$t("createOrder.createOrder74"));
        return false;
      }
      let formdata = new FormData();
      formdata.append("file", file.file);
      formdata.append("modular", "createOrder");
      formdata.append("fileType", "");
      this.$http.post("aliyun/oss/upload", formdata).then((res) => {
        if (res.data.code == 200) {
          let index = this.curRowImg;
          let data = {
            ...this.tableCheck.tableData[index],
            pictureUrl: res.data.data,
            pictureName: res.data.data.split("createOrder/")[1],
          };
          this.tableCheck.setDataList(index, data);
          this.$set(this.tableCheck.tableData, index, data);
          this.$message.success(this.$t("createOrder.createOrder73"));
        } else {
          this.$message.error(this.$t("createOrder.createOrder75"));
        }
      });
    },

    //----- 商品详情相关start--------
    beforeImgUpload(file) {
      if (file.type !== "image/jpeg" && file.type !== "image/jpg" && file.type !== "image/png") {
        this.$message.error(this.$t("createOrder.createOrder74"));
        return false;
      }
      let specialReg = /["<>:;,}{\\/\\|?*]/;
      if (specialReg.test(file.name)) {
        this.$message.error(this.$t("createOrder.specialChar"));
        return false;
      }
      const fileName = file.uid;
      this.listObj[fileName] = {};
      return new Promise((resolve, reject) => {
        this.$http
          .get("aliyun/oss/policy")
          .then((response) => {
            var num = ""; //定义编号
            for (
              var i = 0;
              i < 4;
              i++ //4位随机数，用以加在时间戳后面。
            ) {
              num += Math.floor(Math.random() * 10);
            }
            num = new Date().getTime() + num; //时间戳，用来生成编号。
            const { data = {} } = response.data;
            this.imgDataObj.policy = data.policy;
            this.imgDataObj.signature = data.signature;
            this.imgDataObj.ossaccessKeyId = data.accessKeyId;
            this.imgDataObj.key = data.dir + "/order/" + num + "${filename}";
            this.imgDataObj.dir = data.dir + "/order";
            this.imgDataObj.host = data.host;
            this.imgDataObj.timeStamp = num;
            file.timeStamp = num;
            Oss.imgCompress(file, this.listObj, resolve, reject);
          })
          .catch(() => {
            reject(false);
          });
      });
    },

    //----- 商品详情相关end--------

    beforeUploadImg(index) {
      this.curRowImg = index;
    },
    beforeUploadVideo(index) {
      this.curRowPDF = index;
    },
    beforeUploadFile(index) {
      this.curRowFile = index;
    },
    delFile(row) {
      this.$confirm(this.$t("createOrder.createOrder68"), {
        confirmButtonText: this.$t("submit"),
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: this.$t("cancel"),
        cancelButtonClass: "form-btn btn-gray",
      })
        .then(() => {
          row.inspectionFileName = "";
          row.inspectionFileUrl = "";
          this.$message({
            type: "success",
            message: this.$t("createOrder.createOrder69"),
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("createOrder.createOrder70"),
          });
        });
    },
    async delImg(row, index) {
      this.$confirm(this.$t("createOrder.createOrder71"), {
        confirmButtonText: this.$t("submit"),
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: this.$t("cancel"),
        cancelButtonClass: "form-btn btn-gray",
        type: "warning",
      })
        .then(() => {
          let data = { ...row, pictureUrl: "", pictureName: "" };
          this.tableCheck.setDataList(index, data);
          this.$set(this.tableCheck.tableData, index, data);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("createOrder.createOrder70"),
          });
        });
    },
    //上传pdf
    uploadVideo(file) {
      const fileSuffix = file.file.name.substring(file.file.name.lastIndexOf(".") + 1).toLowerCase();
      const whiteList = ["7z", "rar", "zip", "pdf", "ai"];
      if (whiteList.indexOf(fileSuffix) === -1) {
        // this.$message.error('上传文件只能是 pdf、ai 格式');
        this.$message.error(this.$t("createOrder.createOrder98"));
        return;
      }
      const isLt2M = file.file.size / 1024 / 1024 < 20;
      if (!isLt2M) {
        // this.$message.error('上传文件大小不能超过 20MB');
        this.$message.error(this.$t("createOrder.createOrder97"));
        return;
      }
      let formdata = new FormData();
      formdata.append("file", file.file);
      formdata.append("modular", "OrderDetail");
      formdata.append("fileType", "");
      this.$http.post("aliyun/oss/upload", formdata).then((res) => {
        if (res.data.code == 200) {
          console.log("res---pdf", res);
          let index = this.curRowPDF;
          const newRow = this.tableCheck.tableData[index];
          let pdfArray = newRow.pdfAttachment ? JSON.parse(newRow.pdfAttachment) : [];
          pdfArray.push({
            name: res.data.data.split("OrderDetail/")[1],
            url: res.data.data,
          });
          let data = {
            ...newRow,
            pdfAttachment: JSON.stringify(pdfArray),
          };
          this.tableCheck.setDataList(index, data);
          this.$set(this.tableCheck.tableData, index, data);
          this.$message.success(this.$t("createOrder.createOrder73"));
        }
      });
    },
    //移除pdf文件
    pdfRemove(file, fileList) {
      console.log("file", file);
      console.log("fileList", fileList);
      //保留数据响应
      let index = this.curRowPDF;
      const newRow = this.tableCheck.tableData[index];
      newRow.pdfAttachment = JSON.stringify(fileList);
    },
    beforePdfUpload(file) {
      const _self = this;
      const fileName = file.uid;
      this.pdfListObj[fileName] = {};
      return new Promise((resolve, reject) => {
        this.$http
          .get("aliyun/oss/policy")
          .then((response) => {
            var num = ""; //定义编号
            for (
              var i = 0;
              i < 4;
              i++ //4位随机数，用以加在时间戳后面。
            ) {
              num += Math.floor(Math.random() * 10);
            }
            num = new Date().getTime() + num; //时间戳，用来生成编号。
            const { data = {} } = response.data;
            this.pdfDataObj.policy = data.policy;
            this.pdfDataObj.signature = data.signature;
            this.pdfDataObj.ossaccessKeyId = data.accessKeyId;
            this.pdfDataObj.key = data.dir + "/order/" + num + file.name;
            this.pdfDataObj.dir = data.dir + "/order";
            this.pdfDataObj.host = data.host;
            this.pdfDataObj.timeStamp = num;
            let arr = [
              {
                hasSuccess: true,
                height: undefined,
                uid: file.uid,
                url: this.pdfDataObj.host + "/" + this.pdfDataObj.key,
                width: undefined,
              },
            ];
            this.$emit("successCBK", arr);
            this.pdfListObj = {};
            resolve(true);
          })
          .catch(() => {
            reject(false);
          });
      });
    },
    //上传检品文件
    uploadFile(file) {
      const fileSuffix = file.file.name.substring(file.file.name.lastIndexOf(".") + 1).toLowerCase();
      const whiteList = ["doc", "docx", "xls", "xlsx", "ppt", "pptx", "pdf", "txt", "jpg", "jpeg", "png", "gif", "mp4"];
      if (whiteList.indexOf(fileSuffix) === -1) {
        this.$message.error(this.$t("createOrder.createOrder96"));
        return;
      }
      const isLt2M = file.file.size / 1024 / 1024 < 20;
      if (!isLt2M) {
        this.$message.error(this.$t("createOrder.createOrder97"));
        return;
      }
      let formdata = new FormData();
      formdata.append("file", file.file);
      formdata.append("modular", "OrderDetail");
      formdata.append("fileType", "");
      this.$http.post("aliyun/oss/upload", formdata).then((res) => {
        if (res.data.code == 200) {
          let index = this.curRowFile;
          let data = {
            ...this.tableCheck.tableData[index],
            inspectionFileUrl: res.data.data,
            inspectionFileName: res.data.data.split("OrderDetail/")[1],
          };
          console.log("data", data);
          this.tableCheck.setDataList(index, data);
          this.$set(this.tableCheck.tableData, index, data);
          this.$message.success(this.$t("createOrder.createOrder73"));
        }
      });
    },
    agentFlagchange(agentFlag, index, row) {
      if (agentFlag === "1") {
        row.trackingNumber = "";
      }
      let strRefs = this.sumRulesForm("rulesFreight", index);
      this.$refs[`${strRefs}`].clearValidate(["trackingNumber"]);
    },
    //选择是否fba
    orderTypeChange(val, index, row) {
      if (val == 1) {
        row.fnsku = "";
        row.goodsNameCus = "";
        this.$set(row, "fnskuEnabled", false);
      } else {
        this.$set(row, "fnskuEnabled", true);
        row.skuLabel = this.setSku(row).skuLabel;
        row.skuPlaceolder = this.setSku(row).skuPlaceolder;
      }

      if (val == 0) {
        this.$set(row, "asinRequired", true);
      } else {
        this.$set(row, "asinRequired", false);
      }

      let strRefs = this.sumRulesForm("rulesFBA", index);
      this.$refs[`${strRefs}`].clearValidate(["fnsku", "goodsNameCus", "asin"]);
    },
    // 检品选项选择改变时
    configCheckChanged(row, index) {
      //添加详细检品时，如果已选择简易检品选项，自动去除简易检品
      let flag = false;
      row.checkProjectArray.forEach((item) => {
        if (item == "Detailed inspection") {
          flag = true;
        }
      });
      if (flag) {
        row.checkProjectArray.forEach((item, index) => {
          if (item == "baseCheck") {
            row.checkProjectArray.splice(index, 1);
          }
        });
      }
      if (row.checkProjectArray.length === 0) {
        row.checkProjectArray = defaultCheck;
      }
      if (row.checkProjectArray.includes("laundryLabel")) {
        this.$set(row, "isTempEnabled", true);
      } else {
        row.laundryLabelId = "";
        this.$set(row, "isTempEnabled", false);
      }
      let strRefs = this.sumRulesForm("rulesLabel", index);
      this.$refs[`${strRefs}`].clearValidate(["laundryLabelId"]);
    },
    beforeFileUpload(file) {
      const fileName = file.uid;
      this.fileListObj[fileName] = {};
      return new Promise((resolve, reject) => {
        this.$http
          .get("aliyun/oss/policy")
          .then((response) => {
            const { data = {} } = response.data;
            var num = ""; //定义编号
            for (
              var i = 0;
              i < 4;
              i++ //4位随机数，用以加在时间戳后面。
            ) {
              num += Math.floor(Math.random() * 10);
            }
            num = new Date().getTime() + num; //时间戳，用来生成编号。
            this.fileDataObj.policy = data.policy;
            this.fileDataObj.signature = data.signature;
            this.fileDataObj.ossaccessKeyId = data.accessKeyId;
            this.fileDataObj.key = data.dir + "/order/" + num + file.name;
            this.fileDataObj.dir = data.dir + "/order";
            this.fileDataObj.host = data.host;
            this.fileDataObj.timeStamp = num;
            let arr = [
              {
                hasSuccess: true,
                height: undefined,
                uid: file.uid,
                url: this.fileDataObj.host + "/" + this.fileDataObj.key,
                width: undefined,
              },
            ];
            this.$emit("successCBK", arr);
            this.fileListObj = {};
            resolve(true);
          })
          .catch(() => {
            reject(false);
          });
      });
    },
    verifyData() {
      const { page, tableData, dataSource, selectKeys, selectObjs } = this.tableCheck;
      const v = new FormVerify();
      const rule = (row, index) => {
        const currenPage = Math.ceil(index / page.pageSize); //页码
        let rules = {
          goodsCount: {
            keys: ["isEmpty"],
            msg: [`${this.$t("cart.cart13", [currenPage, index])}：${this.$t("orderList.orderList57")}`],
          },
          price: {
            keys: ["isEmpty"],
            msg: [`${this.$t("cart.cart13", [currenPage, index])}：${this.$t("cart.cart14")}`],
          },
          colour: {
            keys: ["isEmpty"],
            msg: [`${this.$t("cart.cart13", [currenPage, index])}：${this.$t("cart.cart15")}`],
          },
        };
        if (!Number(row.agentFlag)) {
          rules.trackingNumber = {
            keys: ["isEmpty"],
            msg: [`${this.$t("cart.cart13", [currenPage, index])}：${this.$t("orderList.orderList25")}`],
          };
        }
        if (!row.route && row.autoSendFlag === '1') {
          rules.weituo = {
            keys: ["isEmpty"],
            msg: [`${this.$t("cart.cart13", [currenPage, index])}：${this.$t("cart.applyMessage33")}`],
            // msg: [`${this.$t("cart.cart13", [currenPage, index])}：请选择收货信息`],
          };
        }
        if (row.fnskuEnabled) {
          const skuLabel = this.setSku(row).skuLabel;
          rules.fnsku = {
            keys: ["isEmpty","isFnsku"],
            msg: [`${this.$t("cart.cart13", [currenPage, index])}：${this.$t("cart.cart16")}${skuLabel}`,`${this.$t("cart.cart13", [currenPage, index])}：${skuLabel}：${this.$t("login.login29")}`],
          };
          rules.goodsNameCus = {
            keys: ["isEmpty"],
            msg: [`${this.$t("cart.cart13", [currenPage, index])}：店舗商品表示名を入力してください`],
          };

          if (row.asinRequired) {
            rules.asin = {
              keys: ["isEmpty"],
              msg: [`${this.$t("cart.cart13", [currenPage, index])}：：${this.$t("cart.cart17")}`],
            };
          }
        }
        if (row.isTempEnabled) {
          rules.laundryLabelId = {
            keys: ["isEmpty"],
            msg: [`${this.$t("cart.cart13", [currenPage, index])}：${this.$t("cart.cart18")}`],
          };
        }
        return rules;
      };
      dataSource.forEach((row, index) => {
        if (selectKeys.includes(row.id)) {
          let rules = rule(row, index + 1);
          try {
            v.rules(rules, row);
          } catch (err) {
            console.log("rules", rules);
            console.log("verifyData", row);
            throw index;
          }
        }
      });
    },
    // 购物车提交订单
    submitOrder() {
      const { page, tableData, dataSource, selectKeys, selectObjs } = this.tableCheck;
      console.log("tableData", tableData);
      console.log("dataSource", dataSource);
      console.log("selectObjs", selectObjs);
      if (selectObjs.length > 0) {
        this.verifyData();
        this.$confirm(this.$t("cart.cart12"), this.$t("prompt.title"), {
          confirmButtonText: this.$t("submit"),
          confirmButtonClass: "form-btn btn-blue",
          cancelButtonText: this.$t("cancel"),
          cancelButtonClass: "form-btn btn-gray",
          type: "warning",
        }).then(() => {
          this.saveForm(selectObjs).then((ids) => {
            this.postOrderForm(ids);
          });
        });
      } else {
        this.$message.error(this.$t("orderList.orderList125"));
      }
    },
    postOrderForm(ids = []) {
      const params = {
        idList: ids,
      };
      this.$http.post("shopping/vehicle/createOrder", params).then((res) => {
        if (res.data.code === 200) {
          this.isSubmit = true;
          closeBeforeunload();
          this.resetMetaTableList();
          this.$message.success(this.$t("success"));
          this.$nextTick(() => {
            this.$router.push({ name: "orderList" });
          });
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 购物车保存
    saveForm(list = this.tableCheck.dataSource) {
      return new Promise((resolve, reject) => {
        if (list.length > 0) {
          this.$http
            .post("shopping/vehicle/save", {
              orderListStr: JSON.stringify(list),
            })
            .then((res) => {
              if (res.data.code == 200) {
                resolve(res.data.data);
              } else {
                this.$message.error(res.data.message);
                reject();
              }
            });
        }
      });
    },
    // 新增一行
    async addRow() {
      try {
        const res = await this.$http.post("shopping/vehicle/addOne");
        if (res.data.code !== 200 || !res.data.data?.id) {
          this.$message.error(res.data.message || this.$t("error"));
          return null;
        }
        const newRow = { ...formData, id: res.data.data.id, agentFlag: this.agentFlagUser };
        this.tableCheck.shiftRow(newRow);
        return newRow;
      } catch (error) {
        this.$message.error(this.$t("error"));
        return null;
      }
    },
    // 新增一行并回显商品详情数据
    async addNewRow(goodsInfo, isAddMode = false) {
      if (isAddMode) {
        const { dataSource, selectKeys, selectObjs } = this.tableCheck;
        const sourceIndex = dataSource.findIndex((row) => row.id === goodsInfo.id);
        if (sourceIndex < 0) {
          this.$message.error(this.$t("error"));
          return;
        }
        try {
          const updateRes = await this.$http.post("shopping/vehicle/update", goodsInfo);
          if (updateRes.data.code !== 200) {
            this.$message.error(updateRes.data.message || this.$t("error"));
            return;
          }
          const updatedRow = { ...dataSource[sourceIndex], ...goodsInfo };
          this.$set(dataSource, sourceIndex, updatedRow);
          this.tableCheck.page.update();
          const selectedIndex = selectKeys.indexOf(updatedRow.id);
          if (selectedIndex < 0) {
            this.tableCheck.selectAdd(updatedRow);
          } else {
            this.$set(selectObjs, selectedIndex, updatedRow);
          }
          this.$message.success(this.$t("cart.cart33"));
          const blankRow = await this.addRow();
          if (blankRow) {
            this.goodsDialogVisible = false;
          }
        } catch (error) {
          this.$message.error(this.$t("error"));
        }
        return;
      }
      const newRow = { ...formData };
      this.$http.post("shopping/vehicle/addOne").then((res) => {
        if (res.data.code !== 200 || !res.data.data?.id) {
          this.$message.error(res.data.message || this.$t("error"));
          return;
        }
        const newId = res.data.data.id;
        newRow.id = newId;
        newRow.agentFlag = this.agentFlagUser;
        Object.assign(newRow, goodsInfo, { id: newId });
        this.$http.post("shopping/vehicle/update", newRow).then((updateRes) => {
          if (updateRes.data.code === 200) {
            this.tableCheck.shiftRow(newRow);
            this.tableCheck.selectAdd(newRow);
            this.$message.success(this.$t("cart.cart33"));
            this.goodsDialogVisible = false;
          } else {
            this.$message.error(updateRes.data.message || this.$t("error"));
          }
        }).catch(() => {
          this.$message.error(this.$t("error"));
        });
      }).catch(() => {
        this.$message.error(this.$t("error"));
      });
    },
    // 批量删除
    deleteRow() {
      const { page, tableData, dataSource, selectKeys, selectObjs } = this.tableCheck;
      if (selectKeys.length > 0) {
        this.$confirm(this.$t("createOrder.confirmDelete"), this.$t("prompt.title"), {
          confirmButtonText: this.$t("submit"),
          confirmButtonClass: "form-btn btn-blue",
          cancelButtonText: this.$t("cancel"),
          cancelButtonClass: "form-btn btn-gray",
          type: "warning",
        })
          .then(() => {
            const url = "shopping/vehicle/batch/delete";
            const params = {
              idList: selectKeys,
            };
            this.$http.post(url, params).then(() => {
              //批量删除
              for (let i = selectKeys.length - 1; i > -1; i--) {
                let item = selectKeys[i];
                let idx = dataSource.findIndex((val) => item === val.id);
                dataSource.splice(idx, 1);
                selectKeys.splice(i, 1);
                selectObjs.splice(i, 1);
              }
              page.update(1);
              this.tableCheck.selectIsAll();
              this.$message.success(this.$t("success"));
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: this.$t("createOrder.createOrder70"),
            });
          });
      }
    },
    // 获取检品选项
    getInspectionOption() {
      return new Promise((resolve) => {
        this.$http
          .get("order/getNameList", {
            params: { nameClass: "INSPECTION", isPrivate: "0" },
          })
          .then((res) => {
            resolve(res.data.data);
          });
      });
    },
    // 重置源数组长度
    async resetMetaTableList() {
      await this.getCartList();
      this.renderItemInfo();
    },
    // 查询购物车商品
    getCartList() {
      return new Promise((resolve) => {
        this.$http.get("shopping/vehicle/query").then((res) => {
          const { data = [] } = res.data;
          this.metaTableList = data;
          this.tableCheck.loading = false;
          resolve(data);
        });
      });
    },
    // 获取水洗标模板
    getLaundryLabelOption() {
      return new Promise((resolve) => {
        this.$http.get("laundry/label/template/getAll").then((res) => {
          resolve(res.data.data);
        });
      });
    },
    // 获取上次保存时间
    getOldSaveTime() {
      this.$http.get("shopping/vehicle/querySaveTime").then((res) => {
        this.oldSaveTime = res.data.data;
      });
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep .el-dialog__header {
  display: none !important;
}
::v-deep .goods-detail-dialog .el-dialog__header {
  display: block !important;
  padding: 0 20px;
}
::v-deep .goods-detail-dialog {
  max-width: 1320px;
  border-radius: 8px;
  overflow: hidden;
}
::v-deep .goods-detail-dialog .goods-dialog-heading {
  display: flex;
  justify-content: center;
  align-items: baseline;
  gap: 24px;
  min-height: 52px;
  padding: 14px 44px 12px;
  box-sizing: border-box;
  border-bottom: 1px solid #e5eaf0;
  color: #17202e;
}
::v-deep .goods-detail-dialog .goods-dialog-title {
  font-size: 20px;
  line-height: 1.3;
  white-space: nowrap;
}
::v-deep .goods-detail-dialog .goods-dialog-description {
  font-size: 13px;
  line-height: 1.5;
  color: #6b7280;
}
::v-deep .goods-detail-dialog .el-dialog__headerbtn {
  top: 15px;
  right: 20px;
}
::v-deep .goods-detail-dialog .el-dialog__body {
  padding: 16px 24px 20px;
}
@media (max-width: 900px) {
  ::v-deep .goods-detail-dialog .goods-dialog-heading {
    display: block;
    padding: 12px 36px 12px 0;
  }
  ::v-deep .goods-detail-dialog .goods-dialog-description {
    display: block;
    margin-top: 4px;
  }
}
::v-deep .el-dialog__body {
  padding: 0 20px;
}
.cart-container {
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;

  > .full-container-page {
    flex: 1 1 auto;
    min-height: 0;
    height: auto;
    overflow: hidden;
  }

  .cart-search-in-breadcrumb {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    min-width: 590px;

    .search {
      margin: 0 auto 8px;
    }
  }

  ::v-deep .breadcrumb-header {
    position: relative;
    min-height: 66px;
    align-items: flex-start;
  }

  .my-upload-text-mini {
    width: 100%;
  }
  ::v-deep .el-upload-list__item-name {
    width: 310px !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  ::v-deep .el-upload-list__item-status-label {
    right: 10px;
  }
  ::v-deep .el-upload-list__item .el-icon-close {
    top: 7px;
    right: 10px;
  }
}
/*.pdfwj{
    ::v-deep .el-upload-list__item-name{
      width: 310px!important;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-left: -20px;
    }
    ::v-deep .el-upload-list__item-status-label {
      right: -20px;
    }
    ::v-deep .el-upload-list__item .el-icon-close {
      top: 7px;
      right: -20px;
    }
  }*/
/*.jpwj{
    ::v-deep .el-upload-list__item-name{
      width: 310px!important;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-left: -20px;
    }
    ::v-deep .el-upload-list__item-status-label {
      right: 20px;
    }
    ::v-deep .el-upload-list__item .el-icon-close {
      top: 7px;
      right: 20px;
    }
  }*/

:deep(.el-table::before) {
  height: 0;
}

::v-deep(.el-table) {
  max-height: 100%;
  overflow: hidden !important;
}

::v-deep(.el-table__body-wrapper) {
  height: calc(100% - 60px);
  width: 100%;
  overflow: auto !important;
}

.ws-table {
  width: 100%;
  height: auto;
  border: 1px solid #d0e8ff;
  padding: 10px;
  border-collapse: collapse;
}

::v-deep .lx-pointer {
  width: 14px !important;
  height: 14px !important;
}

.cart-container {
  .top-info-row {
    display: flex;
    align-items: center;
  }

  .row-left,
  .row-right {
    display: flex;
    align-items: center;
  }

  .row-left > .el-row,
  .row-right > div {
    width: 100%;
  }

  .Accessories-title {
    height: 30px;
    line-height: 30px;
    text-align: center;
    padding: 0;
    white-space: nowrap;
    font-size: 12px;
  }

  .download {
    margin-top: 16px;
    width: 220px;
  }

  .Accessories {
    border-top: 1px solid #e5e9f8;
    border-right: 1px solid #e5e9f8;
  }

  .Accessories .el-col {
    height: 30px;
    line-height: 30px;
    padding: 0 2px;
    border-left: 1px solid #e5e9f8;
    border-bottom: 1px solid #e5e9f8;
    text-align: center;
    white-space: nowrap;
    font-size: 12px;
    /* overflow:auto; */
  }

  .add-form /deep/ .el-form-item__label {
    text-align: left !important;
    padding: 0 5px 0 0 !important;
  }

  /deep/ .el-form-item {
    margin-bottom: 15px !important;
  }

  .add-form /deep/ .el-form-item__error {
    padding-top: 0 !important;
  }

  .add-form /deep/ .el-input--small .el-input__inner {
    padding-left: 2px !important;
  }

  .addOrder-btn-container {
    // position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 45px;
    background-color: #fff;
    box-shadow: 0 0 12px 2px rgba(0, 0, 0, 0.04);
    z-index: 1200;
  }

  .mini-label {
    white-space: nowrap;
  }

  .mini-label /deep/ .el-form-item__content {
    margin-left: 16px !important;
  }

  .mini-label /deep/ .el-form-item__label-wrap {
    margin-left: 0 !important;
  }

  .no-label /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }

  .no-label /deep/ .el-form-item__label-wrap {
    margin-left: 0 !important;
  }

  .lx-label-ml-0 /deep/ .el-form-item__label-wrap {
    margin-left: 10px !important;
  }

  .lx-label-ml-0 /deep/ .el-form-item__content {
    margin-left: 76px !important;
  }

  ul,
  li {
    list-style: none;
  }

  .app-container {
    width: 100%;
    height: 100%;
    overflow: auto;
  }

  .left {
    float: left;
  }

  .overflow {
    overflow: hidden;
  }

  .bottom-img {
    width: 260px;
    margin: 10px auto 0 auto;
    overflow: hidden;
  }

  .sm-img {
    float: left;
    margin-right: 6px;
    border: 2px solid transparent;
    overflow: hidden;
  }

  .sm-img-selected {
    float: left;
    margin-right: 6px;
    border: 2px solid darkred;
    overflow: hidden;
  }

  .sm-img img {
    width: 40px;
    height: 40px;
    float: left;
  }

  .name-container {
    min-height: 21px;
    font-size: 16px;
    font-weight: 700;
    line-height: 21px;
    padding: 0 0 10px 0;
    border-bottom: 1px solid #ccc;
    margin-bottom: 10px;
  }

  .tag-top {
    width: 33%;
  }

  .title-top {
    display: inline-block;
    margin-right: 6px;
    color: #6c6c6c;
    width: 70px;
  }

  .title {
    display: inline-block;
    margin-right: 6px;
    color: #6c6c6c;
    width: 66px;
  }

  /* .unit{
        color: red;
        font-size: 16px;
    } */
  .product-detail /deep/ .el-form-item__label {
    text-align: left;
  }

  .upload-container .editor-slide-upload {
    margin-bottom: 20px;
  }

  .upload-demo {
    float: right;
    margin-left: 10px;
  }

  .line-height-30 /deep/ .el-form-item__content {
    line-height: 30px !important;
  }

  .style-table {
    /deep/ .el-form-item__label-wrap {
      margin-left: 0 !important;
      margin-bottom: -10px;
    }

    /deep/ .el-form-item__content {
      margin-left: 0 !important;
    }
  }

  @media screen and (min-width: 1000px) and (max-width: 1550px) {
    .row-left {
      width: 40% !important;
    }

    .row-right {
      width: 60% !important;
    }

    .search-btn {
      padding-left: 5px !important;
      padding-right: 5px !important;
    }
  }
}
::v-deep.el-form-item.foldLabel .el-form-item__label {
  white-space: pre-line;
  height: 40px;
  line-height: 14px !important;
  margin-top: 10px;
  display: flex;
  justify-items: right;
}
.small-span {
  position: relative;
  top: -20px;
  font-size: 10px;
  color: red;
}

.aabbcc{
  ::v-deep .el-form-item__label{
    font-size: 12px;
  }
}

/* 针对多选下拉框的最大高度控制 */
.height-limited-select :deep(.el-select__tags) {
  max-height: 180px !important;
  min-height: 32px; /* 与 size="small" 对应 */
  overflow-y: auto !important;
  overflow-x: hidden !important;
  flex-wrap: wrap;
  align-content: flex-start;
}

/* 确保标签正确换行 */
.height-limited-select :deep(.el-select__tags .el-tag) {
  margin: 5px 4px 5px 2px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-left: 5px;
}

.height-limited-select :deep(.el-select-dropdown__list) {
  max-height: 300px;
  overflow-y: auto;
}
</style>
